import PaginaNaoEncontrada from '@/views/pages/commons/pagina-nao-encontrada/PaginaNaoEncontrada'
import ValidarDocumento from '@/views/pages/commons/validar-documento/ValidarDocumento'
import ConsultaDeLicitacoes from '@/views/pages/commons/licitacao/consulta-licitacoes/ConsultaDeLicitacoes'
import LicitacaoVisualizacao from '@/views/pages/commons/licitacao/detalhe/LicitacaoVisualizacao'
import LicitacaoVisualizacaoAcompanhamento from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoAcompanhamento'
import LicitacaoVisualizacaoDadosGerais from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoDadosGerais'
import LicitacaoVisualizacaoDadosEdital from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoDadosEdital'
import LicitacaoVisualizacaoEsclarecimentoImpugnacao from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoEsclarecimentoImpugnacao'
import LicitacaoVisualizacaoSimularProposta from '@/views/pages/commons/licitacao/detalhe/etapas-visualizacao/LicitacaoVisualizacaoSimularProposta'
import ValidarCodigoEmail from '@/views/pages/commons/validar-codigo-email/ValidarCodigoEmail'

export default [
    {
        path: '/',
        name: 'home',
        redirect: '/consulta-licitacoes',
    },
    {
        path: '/consulta-licitacoes',
        name: 'consultaDeLicitacoes',
        component: ConsultaDeLicitacoes,
        meta: {
            page: {
                title: 'Editais',
            },
        }
    },
    {
        path: '/licitacao-visualizacao/:id',
        name: 'licitacaoVisualizacao',
        component: LicitacaoVisualizacao,
        redirect: '/licitacao-visualizacao/:id/dados-gerais',
        children:[
            {
                path: 'dados-gerais',
                name: 'licitacaoVisualizacaoDadosGerais',
                component: LicitacaoVisualizacaoDadosGerais,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Esclarecimento e Impugnação'
                    }
                }
            },
            {
                path: 'dados-edital',
                name: 'licitacaoVisualizacaoEdital',
                component: LicitacaoVisualizacaoDadosEdital,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Esclarecimento e Impugnação'
                    }
                }
            },
            {
                path: 'esclarecimento-impugnacao',
                name: 'licitacaoVisualizacaoEsclarecimentoImpugnacao',
                component: LicitacaoVisualizacaoEsclarecimentoImpugnacao,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Esclarecimento e Impugnação'
                    }
                }
            },            {
                path: 'simular-proposta',
                name: 'licitacaoVisualizacaoSimularProposta',
                component: LicitacaoVisualizacaoSimularProposta,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Simular Proposta'
                    }
                }
            },
            {
                path: 'acompanhamento',
                name: 'licitacaoVisualizacaoAcompanhamento',
                component: LicitacaoVisualizacaoAcompanhamento,
                meta: {
                    page: {
                        title: 'Licitação',
                        subtitle: 'Acompanhamento'
                    }
                }
            },
        ]
    },
    {
        path: '/validar-documento',
        name: 'ValidarDocumento',
        component: ValidarDocumento,
        meta: {
            page: {
                title: 'Documento',
                subtitle: 'Validar Documento'
            },
        }
    },
    {
        path: '/validar-documento/:codigo',
        name: 'ValidarDocumentoDireto',
        component: ValidarDocumento,
        meta: {
            page: {
                title: 'Documento',
                subtitle: 'Validar Documento'
            },
        }
    },
    {
        path: '*',
        name: 'PaginaNaoEncontrada',
        component: PaginaNaoEncontrada,
        meta: {
            page: {
                title: 'Ooops',
                subtitle: 'Página não encontrada'
            },
            scrollToTop: false
        }
    },
    {
        path: '/esclarecimento-impugnacao/confirmar/:codigo',
        name: 'ValidarCodigoEmailDireto',
        component: ValidarCodigoEmail
    },
]
